// src/index.ts
var exists = (x) => {
  return x === void 0 || x === null ? false : true;
};
export {
  exists
};
//# sourceMappingURL=index.mjs.map